// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}
/*!
  Theme: Tomorrow Night
  Author: Chris Kempson (http://chriskempson.com)
  License: ~ MIT (or more permissive) [via base16-schemes-source]
  Maintainer: @highlightjs/core-team
  Version: 2021.09.0
*/
/*
  WARNING: DO NOT EDIT THIS FILE DIRECTLY.

  This theme file was auto-generated from the Base16 scheme tomorrow-night
  by the Highlight.js Base16 template builder.

  - https://github.com/highlightjs/base16-highlightjs
*/
/*
base00  #2d2d2d  Default Background
base01  #393939  Lighter Background (Used for status bars, line number and folding marks)
base02  #515151  Selection Background
base03  #999999  Comments, Invisibles, Line Highlighting
base04  #b4b7b4  Dark Foreground (Used for status bars)
base05  #cccccc  Default Foreground, Caret, Delimiters, Operators
base06  #e0e0e0  Light Foreground (Not often used)
base07  #ffffff  Light Background (Not often used)
base08  #f2777a  Variables, XML Tags, Markup Link Text, Markup Lists, Diff Deleted
base09  #f99157  Integers, Boolean, Constants, XML Attributes, Markup Link Url
base0A  #ffcc66  Classes, Markup Bold, Search Text Background
base0B  #99cc99  Strings, Inherited Class, Markup Code, Diff Inserted
base0C  #66cccc  Support, Regular Expressions, Escape Characters, Markup Quotes
base0D  #6699cc  Functions, Methods, Attribute IDs, Headings
base0E  #cc99cc  Keywords, Storage, Selector, Markup Italic, Diff Changed
base0F  #a3685a  Deprecated, Opening/Closing Embedded Language Tags, e.g. <?php ?>
*/
pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}
.hljs {
  color: #cccccc;
  background: #2d2d2d
}
.hljs::selection,
.hljs ::selection {
  background-color: #515151;
  color: #cccccc
}
/* purposely do not highlight these things */
.hljs-formula,
.hljs-params,
.hljs-property {
  
}
/* base03 - #999999 -  Comments, Invisibles, Line Highlighting */
.hljs-comment {
  color: #999999
}
/* base04 - #b4b7b4 -  Dark Foreground (Used for status bars) */
.hljs-tag {
  color: #b4b7b4
}
/* base05 - #cccccc -  Default Foreground, Caret, Delimiters, Operators */
.hljs-subst,
.hljs-punctuation,
.hljs-operator {
  color: #cccccc
}
.hljs-operator {
  opacity: 0.7
}
/* base08 - Variables, XML Tags, Markup Link Text, Markup Lists, Diff Deleted */
.hljs-bullet,
.hljs-variable,
.hljs-template-variable,
.hljs-selector-tag,
.hljs-name,
.hljs-deletion {
  color: #f2777a
}
/* base09 - Integers, Boolean, Constants, XML Attributes, Markup Link Url */
.hljs-symbol,
.hljs-number,
.hljs-link,
.hljs-attr,
.hljs-variable.constant_,
.hljs-literal {
  color: #f99157
}
/* base0A - Classes, Markup Bold, Search Text Background */
.hljs-title,
.hljs-class .hljs-title,
.hljs-title.class_ {
  color: #ffcc66
}
.hljs-strong {
  font-weight: bold;
  color: #ffcc66
}
/* base0B - Strings, Inherited Class, Markup Code, Diff Inserted */
.hljs-code,
.hljs-addition,
.hljs-title.class_.inherited__,
.hljs-string {
  color: #99cc99
}
/* base0C - Support, Regular Expressions, Escape Characters, Markup Quotes */
/* guessing */
.hljs-built_in,
.hljs-doctag,
.hljs-quote,
.hljs-keyword.hljs-atrule,
.hljs-regexp {
  color: #66cccc
}
/* base0D - Functions, Methods, Attribute IDs, Headings */
.hljs-function .hljs-title,
.hljs-attribute,
.ruby .hljs-property,
.hljs-title.function_,
.hljs-section {
  color: #6699cc
}
/* base0E - Keywords, Storage, Selector, Markup Italic, Diff Changed */
/* .hljs-selector-id, */
/* .hljs-selector-class, */
/* .hljs-selector-attr, */
/* .hljs-selector-pseudo, */
.hljs-type,
.hljs-template-tag,
.diff .hljs-meta,
.hljs-keyword {
  color: #cc99cc
}
.hljs-emphasis {
  color: #cc99cc;
  font-style: italic
}
/* base0F - Deprecated, Opening/Closing Embedded Language Tags, e.g. <?php ?> */
/*
  prevent top level .keyword and .string scopes
  from leaking into meta by accident
*/
.hljs-meta,
.hljs-meta .hljs-keyword,
.hljs-meta .hljs-string {
  color: #a3685a
}
/* for v10 compatible themes */
.hljs-meta .hljs-keyword,
.hljs-meta-keyword {
  font-weight: bold
}`, "",{"version":3,"sources":["webpack://./node_modules/highlight.js/styles/base16/tomorrow-night.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;AACA;EACE;AACF;AACA;;;;;;CAMC;AACD;;;;;;;CAOC;AACD;;;;;;;;;;;;;;;;;CAiBC;AACD;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;AACA;EACE;AACF;AACA;EACE,cAAc;EACd;AACF;AACA;;EAEE,yBAAyB;EACzB;AACF;AACA,4CAA4C;AAC5C;;;;AAIA;AACA,gEAAgE;AAChE;EACE;AACF;AACA,+DAA+D;AAC/D;EACE;AACF;AACA,yEAAyE;AACzE;;;EAGE;AACF;AACA;EACE;AACF;AACA,+EAA+E;AAC/E;;;;;;EAME;AACF;AACA,2EAA2E;AAC3E;;;;;;EAME;AACF;AACA,0DAA0D;AAC1D;;;EAGE;AACF;AACA;EACE,iBAAiB;EACjB;AACF;AACA,kEAAkE;AAClE;;;;EAIE;AACF;AACA,4EAA4E;AAC5E,aAAa;AACb;;;;;EAKE;AACF;AACA,yDAAyD;AACzD;;;;;EAKE;AACF;AACA,sEAAsE;AACtE,uBAAuB;AACvB,0BAA0B;AAC1B,yBAAyB;AACzB,2BAA2B;AAC3B;;;;EAIE;AACF;AACA;EACE,cAAc;EACd;AACF;AACA,+EAA+E;AAC/E;;;CAGC;AACD;;;EAGE;AACF;AACA,8BAA8B;AAC9B;;EAEE;AACF","sourcesContent":["pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em\n}\ncode.hljs {\n  padding: 3px 5px\n}\n/*!\n  Theme: Tomorrow Night\n  Author: Chris Kempson (http://chriskempson.com)\n  License: ~ MIT (or more permissive) [via base16-schemes-source]\n  Maintainer: @highlightjs/core-team\n  Version: 2021.09.0\n*/\n/*\n  WARNING: DO NOT EDIT THIS FILE DIRECTLY.\n\n  This theme file was auto-generated from the Base16 scheme tomorrow-night\n  by the Highlight.js Base16 template builder.\n\n  - https://github.com/highlightjs/base16-highlightjs\n*/\n/*\nbase00  #2d2d2d  Default Background\nbase01  #393939  Lighter Background (Used for status bars, line number and folding marks)\nbase02  #515151  Selection Background\nbase03  #999999  Comments, Invisibles, Line Highlighting\nbase04  #b4b7b4  Dark Foreground (Used for status bars)\nbase05  #cccccc  Default Foreground, Caret, Delimiters, Operators\nbase06  #e0e0e0  Light Foreground (Not often used)\nbase07  #ffffff  Light Background (Not often used)\nbase08  #f2777a  Variables, XML Tags, Markup Link Text, Markup Lists, Diff Deleted\nbase09  #f99157  Integers, Boolean, Constants, XML Attributes, Markup Link Url\nbase0A  #ffcc66  Classes, Markup Bold, Search Text Background\nbase0B  #99cc99  Strings, Inherited Class, Markup Code, Diff Inserted\nbase0C  #66cccc  Support, Regular Expressions, Escape Characters, Markup Quotes\nbase0D  #6699cc  Functions, Methods, Attribute IDs, Headings\nbase0E  #cc99cc  Keywords, Storage, Selector, Markup Italic, Diff Changed\nbase0F  #a3685a  Deprecated, Opening/Closing Embedded Language Tags, e.g. <?php ?>\n*/\npre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em\n}\ncode.hljs {\n  padding: 3px 5px\n}\n.hljs {\n  color: #cccccc;\n  background: #2d2d2d\n}\n.hljs::selection,\n.hljs ::selection {\n  background-color: #515151;\n  color: #cccccc\n}\n/* purposely do not highlight these things */\n.hljs-formula,\n.hljs-params,\n.hljs-property {\n  \n}\n/* base03 - #999999 -  Comments, Invisibles, Line Highlighting */\n.hljs-comment {\n  color: #999999\n}\n/* base04 - #b4b7b4 -  Dark Foreground (Used for status bars) */\n.hljs-tag {\n  color: #b4b7b4\n}\n/* base05 - #cccccc -  Default Foreground, Caret, Delimiters, Operators */\n.hljs-subst,\n.hljs-punctuation,\n.hljs-operator {\n  color: #cccccc\n}\n.hljs-operator {\n  opacity: 0.7\n}\n/* base08 - Variables, XML Tags, Markup Link Text, Markup Lists, Diff Deleted */\n.hljs-bullet,\n.hljs-variable,\n.hljs-template-variable,\n.hljs-selector-tag,\n.hljs-name,\n.hljs-deletion {\n  color: #f2777a\n}\n/* base09 - Integers, Boolean, Constants, XML Attributes, Markup Link Url */\n.hljs-symbol,\n.hljs-number,\n.hljs-link,\n.hljs-attr,\n.hljs-variable.constant_,\n.hljs-literal {\n  color: #f99157\n}\n/* base0A - Classes, Markup Bold, Search Text Background */\n.hljs-title,\n.hljs-class .hljs-title,\n.hljs-title.class_ {\n  color: #ffcc66\n}\n.hljs-strong {\n  font-weight: bold;\n  color: #ffcc66\n}\n/* base0B - Strings, Inherited Class, Markup Code, Diff Inserted */\n.hljs-code,\n.hljs-addition,\n.hljs-title.class_.inherited__,\n.hljs-string {\n  color: #99cc99\n}\n/* base0C - Support, Regular Expressions, Escape Characters, Markup Quotes */\n/* guessing */\n.hljs-built_in,\n.hljs-doctag,\n.hljs-quote,\n.hljs-keyword.hljs-atrule,\n.hljs-regexp {\n  color: #66cccc\n}\n/* base0D - Functions, Methods, Attribute IDs, Headings */\n.hljs-function .hljs-title,\n.hljs-attribute,\n.ruby .hljs-property,\n.hljs-title.function_,\n.hljs-section {\n  color: #6699cc\n}\n/* base0E - Keywords, Storage, Selector, Markup Italic, Diff Changed */\n/* .hljs-selector-id, */\n/* .hljs-selector-class, */\n/* .hljs-selector-attr, */\n/* .hljs-selector-pseudo, */\n.hljs-type,\n.hljs-template-tag,\n.diff .hljs-meta,\n.hljs-keyword {\n  color: #cc99cc\n}\n.hljs-emphasis {\n  color: #cc99cc;\n  font-style: italic\n}\n/* base0F - Deprecated, Opening/Closing Embedded Language Tags, e.g. <?php ?> */\n/*\n  prevent top level .keyword and .string scopes\n  from leaking into meta by accident\n*/\n.hljs-meta,\n.hljs-meta .hljs-keyword,\n.hljs-meta .hljs-string {\n  color: #a3685a\n}\n/* for v10 compatible themes */\n.hljs-meta .hljs-keyword,\n.hljs-meta-keyword {\n  font-weight: bold\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
